export const hobbies_data = [
    {
      name: "ESP32 Rack LED Bar",
      description: "Custom-built LED status bar for server racks using ESP32 microcontroller. Real-time monitoring with addressable RGB LEDs for visual system status.",
      url: "https://github.com/chris17453/ESP32LedRackBar",
      type: "github",
      icon: "cpu",
      image: "static/led-bar.gif"
    },
    {
      name: "Synthra AI Webcam",
      description: "AI-powered webcam for Linux that adds real-time effects and filters using machine learning. Creates virtual camera devices for streaming.",
      url: "https://www.youtube.com/watch?v=ORrxxhilm2M&t=19s",
      type: "youtube",
      icon: "sparkles",
      image: "https://img.youtube.com/vi/ORrxxhilm2M/maxresdefault.jpg"
    },
    {
      name: "Injectomatic",
      description: "Micro keyboard device for auto-generating commit messages. Hardware solution for developers who hate writing commit messages.",
      url: "https://www.youtube.com/watch?v=95b1C7n4zQc",
      type: "youtube",
      icon: "keyboard",
      image: "https://img.youtube.com/vi/95b1C7n4zQc/maxresdefault.jpg"
    }
  
  ];